module.exports = __webpack_public_path__ + "img/guide-ja-2.c1db2fd5.png";